import { useWeb3React } from "@web3-react/core";
import { useEffect, useState } from "react";
import { RibbonCoveredCallFactory } from "../codegen/RibbonCoveredCallFactory";
import { VaultAddressMap } from "../constants/constants";
export var getVault = function (library, vaultOption, useSigner) {
    if (useSigner === void 0) { useSigner = true; }
    if (library) {
        var provider = useSigner ? library.getSigner() : library;
        var vault = RibbonCoveredCallFactory.connect(VaultAddressMap[vaultOption].v1, provider);
        return vault;
    }
    return null;
};
var useVault = function (vaultOption) {
    var _a = useWeb3React(), library = _a.library, active = _a.active;
    var _b = useState(null), vault = _b[0], setVault = _b[1];
    useEffect(function () {
        if (active && library) {
            var vault_1 = getVault(library, vaultOption);
            setVault(vault_1);
        }
    }, [library, active, vaultOption]);
    return vault;
};
export default useVault;
//# sourceMappingURL=useVault.js.map